import React from "react";
import {
  Button,
  Card,
  CardBody,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
import { Form } from "antd";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faKey } from "@fortawesome/free-solid-svg-icons";
import { CustomBackground } from "components";
import { useDispatch } from "react-redux";
import { userLogin } from "redux/actions/auth";
import { useSelector } from "react-redux";
import Spinner from "../../helpers/spin";
import { Redirect } from "react-router";

const SignIn = ({ isLogin }) => {
  const [form] = Form.useForm();
  const { isLoading } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();
  const onFinish = (data) => {
    dispatch(userLogin({ ...data, username: data.email }));
  };
  if (isLogin) return <Redirect to="/profile" />;
  return (
    <section className="section section-shaped section-xl">
      <CustomBackground />
      <Container className="pt-lg-7">
        <Row className="justify-content-center">
          <Col lg="5">
            <Card className="bg-secondary shadow border-0">
              <CardBody className="px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                  <h5>Member Sign In</h5>
                </div>
                <Form form={form} onFinish={onFinish} role="form">
                  <Form.Item
                    name="email"
                    rules={[
                      { required: true, message: "Email is required" },
                      {
                        type: "email",
                        transform: (val) => val.trim(),
                        message: "Email is not valid",
                      },
                    ]}
                    className="mb-3"
                  >
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <FontAwesomeIcon icon={faEnvelope} />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input placeholder="Email" />
                    </InputGroup>
                  </Form.Item>
                  <Form.Item name="password" rules={[{ required: true }]}>
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <FontAwesomeIcon icon={faKey} />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Password"
                        type="password"
                        autoComplete="off"
                      />
                    </InputGroup>
                  </Form.Item>
                  {/* <div className="custom-control custom-control-alternative custom-checkbox">
                      <input
                        className="custom-control-input"
                        id=" customCheckLogin"
                        type="checkbox"
                      />
                      <label
                        className="custom-control-label"
                        htmlFor=" customCheckLogin"
                      >
                        <span>Remember me</span>
                      </label>
                    </div> */}
                  <div className="text-center">
                    <Form.Item>
                      <Button
                        disabled={isLoading}
                        className="button-loading my-4"
                        color="primary"
                      >
                        Sign in {isLoading && <Spinner />}
                      </Button>
                    </Form.Item>
                  </div>
                </Form>
              </CardBody>
            </Card>
            <Row className="mt-3">
              <Col xs="6">
                <a className="text-light" href="/forget-password">
                  <medium>Forgot password?</medium>
                </a>
              </Col>
              <Col className="text-right" xs="6">
                <a className="text-light" href="/sign-up">
                  <medium>Sign Up</medium>
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SignIn;
